export default __webpack_public_path__ + "static/media/listOfPunchIns.942d50e3.png";